// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GooglePlayLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.224 13.838 7.25 1.83a2.53 2.53 0 0 0-2.515.008A2.453 2.453 0 0 0 3.5 3.98v24.04a2.452 2.452 0 0 0 1.239 2.141 2.527 2.527 0 0 0 2.515.008l20.97-12a2.47 2.47 0 0 0 0-4.325v-.006ZM6.5 25.375V6.625L15.875 16 6.5 25.375Zm11.5-7.25 1.55 1.55-7.25 4.15 5.7-5.7Zm-5.699-9.946 7.25 4.15L18 13.875l-5.699-5.696Zm9.949 9.946L20.125 16l2.125-2.125L25.965 16l-3.715 2.125Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
